import { render, staticRenderFns } from "./StoreReview.vue?vue&type=template&id=5b678fef&scoped=true&"
import script from "./StoreReview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StoreReview.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b678fef",
  null
  
)

export default component.exports